import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "p",
  "ul",
  "ol",
  "li",
  "strong",
  "em",
  "b",
  "i",
  "u",
  "a",
  "br",
  "blockquote",
  "span",
];

const ALLOWED_ATTR = ["href", "target", "rel", "class"];

export function sanitizePolicyHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}

/** Normalize GET common/get-privacy-policy-data response. */
export function parsePrivacyPolicyResponse(axiosPayload) {
  const empty = {
    title: "Privacy Policy & Terms",
    contentHtml: "",
    rules: [],
    updatedOn: null,
  };

  if (!axiosPayload) return empty;

  const envelope = axiosPayload.data != null && axiosPayload.status == null
    ? axiosPayload
    : axiosPayload;

  const status = envelope.status ?? envelope.Status;
  const data = envelope.data ?? envelope.Data;

  if (status != null && Number(status) !== 200) {
    return empty;
  }

  if (Array.isArray(data)) {
    return {
      ...empty,
      rules: data
        .map((row) => {
          if (typeof row === "string") return row.trim();
          if (row && typeof row === "object") {
            const text = row.rules ?? row.Rules ?? row.text ?? row.Text;
            return text != null ? String(text).trim() : "";
          }
          return row != null ? String(row).trim() : "";
        })
        .filter(Boolean),
    };
  }

  if (data && typeof data === "object") {
    const rules = Array.isArray(data.rules ?? data.Rules)
      ? (data.rules ?? data.Rules).filter(Boolean)
      : [];
    return {
      title: data.title ?? data.Title ?? empty.title,
      contentHtml: sanitizePolicyHtml(data.contentHtml ?? data.ContentHtml ?? ""),
      rules,
      updatedOn: data.updatedOn ?? data.UpdatedOn ?? null,
    };
  }

  return empty;
}
